import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Homeimg1 from "./Homeimg1.jpg";
import Homeimg2 from "./Homeimg2.png";
import Homeimg3 from "./Homeimg3.png";
import Homeimg4 from "./Homeimg4.png";
import Homeimg5 from "./Homeimg5.png";
import Homeimg6 from "./Homeimg6.png";

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const nextIndex = (index + 1) % 3; // Change 3 to the number of images in your carousel
  //     setIndex(nextIndex);
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, [index]);

  return (
    <Carousel >
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg1}
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg2}
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg3}
          alt="Third slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg4}
          alt="Forth slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg5}
          alt="Fifth slide"
        />
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Homeimg6}
          alt="Sixth slide"
        />
      </Carousel.Item>
    </Carousel>
  );
}

export default ControlledCarousel;
